import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ShipperOrderFormWrapper, ShipperOrderForm } from 'modules/shipper-order/Form';
import { Modal } from '@ontruck/orc';

import { isMainLoading } from 'redux/modules/shipper-order-form/selectors';

import {
  getCurrentShipperOrder,
  getShipperWarning,
  getTimeWarning,
  isModalOpened,
} from 'redux/modules/shipper-order-new/selectors';

import { toggleModal, submitForm, initForm } from 'redux/modules/shipper-order-new/effects';

import FormModalHeader from 'modules/shipper-order/FormModalHeader';

import { StyledLoading } from 'modules/Common/form/styled';

import JourneyCostModal from 'modules/journey/CostModal';

import {
  DAY_HOLIDAY_EXTRA,
  PRICE_INCREMENT_EXTRA,
  DISCOUNT_EXTRA,
  RETURN_EXTRA,
  NEGOTIATED_EXTRA,
} from 'modules/shipper-order/Form/constants';
import { FormError } from 'modules/shipper-order/Form/fields';
import { TenantExtras } from 'tenant/bussines';
import { injectIntl } from 'react-intl';

class NewModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillUnmount() {
    const { toggleModal } = this.props;

    toggleModal(false);
  }

  componentDidMount() {
    const { initForm, initialShipperOrder, toggleModal } = this.props;

    toggleModal(true);
    initForm(initialShipperOrder);
  }

  handleSubmit(shipperOrder) {
    const { submitForm } = this.props;

    submitForm(shipperOrder);
  }

  handleClose() {
    const { history, toggleModal } = this.props;

    const { action } = history;
    toggleModal(false);

    if (action === 'PUSH') {
      history.goBack();
      return;
    }

    history.push('/');
  }

  render() {
    const { intl } = this.props;
    const t = intl.messages.modules.NewModal;
    const { initialShipperOrder, mainLoading, timeWarning, shipperWarning } = this.props;
    if (mainLoading || !initialShipperOrder) {
      return (
        <Modal onClose={this.handleClose} show={true} size="XL" headerComponent={t.title}>
          <StyledLoading />
        </Modal>
      );
    }
    const activeExtras = TenantExtras?.activeExtras || [
      DAY_HOLIDAY_EXTRA,
      PRICE_INCREMENT_EXTRA,
      DISCOUNT_EXTRA,
      NEGOTIATED_EXTRA,
      RETURN_EXTRA,
    ];
    return (
      <Fragment>
        <ShipperOrderFormWrapper
          initialShipperOrder={initialShipperOrder}
          onSubmit={this.handleSubmit}
        >
          {(formikProps) => (
            <Modal
              onClose={this.handleClose}
              show={true}
              size="XL"
              headerComponent={
                <FormModalHeader
                  showCancelButton={false}
                  typeSelectorDisabled={false}
                  showClearButton
                  isNew
                  {...formikProps}
                />
              }
            >
              <ShipperOrderForm
                shipperWarning={shipperWarning}
                submitText={t.submit}
                showCloseWithoutSavingButton={false}
                activeExtras={activeExtras}
                showDriverAndVehicle={true}
                {...formikProps}
              />
            </Modal>
          )}
        </ShipperOrderFormWrapper>
        {!!timeWarning && !shipperWarning && <FormError type="times" warnings={timeWarning} />}
        {!!shipperWarning && (
          <FormError key={shipperWarning.id} type="shipper" warnings={shipperWarning} />
        )}
        <JourneyCostModal />
      </Fragment>
    );
  }
}

NewModal.propTypes = {
  toggleModal: PropTypes.func,
  submitForm: PropTypes.func,
  opened: PropTypes.bool,
  history: PropTypes.object.isRequired,
  initialShipperOrder: PropTypes.object.isRequired,
  initForm: PropTypes.func.isRequired,
  mainLoading: PropTypes.bool,
};

NewModal.defaultProps = {
  mainLoading: false,
};

const actionCreators = {
  toggleModal,
  submitForm,
  initForm,
};

export default injectIntl(
  connect(
    (state) => ({
      opened: isModalOpened(state),
      mainLoading: isMainLoading(state),
      initialShipperOrder: getCurrentShipperOrder(state),
      timeWarning: getTimeWarning(state),
      shipperWarning: getShipperWarning(state),
    }),
    actionCreators
  )(withRouter(NewModal))
);
